import cn from 'classnames'
import { timezoneDate } from 'utils/helpers'

import s from './DateInfo.scss'

const followUpStatuses = ['SENT', 'RECEIVED']

const DateInfo = ({ status, followUpDate, dueDate }) => {
  return (
    <div className={cn(s.dueDate, s.pullLeft)}>
      {followUpStatuses.includes(status) && followUpDate
        ? timezoneDate(followUpDate)
        : dueDate
          ? timezoneDate(dueDate)
          : ''}
    </div>
  )
}

export default DateInfo
